import { render, staticRenderFns } from "./TsSimpleKeyboard.vue?vue&type=template&id=1dbdd6aa&scoped=true"
import script from "./TsSimpleKeyboard.vue?vue&type=script&lang=js"
export * from "./TsSimpleKeyboard.vue?vue&type=script&lang=js"
import style0 from "./TsSimpleKeyboard.vue?vue&type=style&index=0&id=1dbdd6aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbdd6aa",
  null
  
)

export default component.exports